export enum VisibilityType {
  UNCATEGORIZED = 'uncategorized',
  PRIVATE = 'private',
  SCHOOL_ONLY = 'schoolOnly'
}

export type Visibility = VisibilityType.PRIVATE | VisibilityType.SCHOOL_ONLY | VisibilityType.UNCATEGORIZED;

export interface CreateBookmarkProblemListRequest {
  subjectId: string;
  name: string;
  visibility: Visibility;
}

export interface CreateBookmarkProblemListResponse {
  id: string;
  userId: string;
  schoolId: string;
  subjectId: string;
  folderId: string | null; // null固定
  name: string;
  visibility: Visibility;
  problemCount: number; // 0固定
  createdAt: string;
  updatedAt: string;
}
